import { render, staticRenderFns } from "./RiskRecurrence.html?vue&type=template&id=45cdd906&scoped=true&"
import script from "./RiskRecurrence.vue?vue&type=script&lang=js&"
export * from "./RiskRecurrence.vue?vue&type=script&lang=js&"
import style0 from "./RiskRecurrence.scss?vue&type=style&index=0&id=45cdd906&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cdd906",
  null
  
)

export default component.exports